import { Reveal, RevealLine } from "../lib/motion";
import { useCountUp } from "../lib/useCountUp";

const YearsValue = () => {
  const { ref, value } = useCountUp(18);
  return (
    <span ref={ref} className="font-serif text-5xl sm:text-6xl text-[var(--ink)] tracking-tight">
      {value}<span className="text-[var(--gold)]">+</span>
    </span>
  );
};

const BLOCKS = [
  { value: <YearsValue />, caption: "Anni di esperienza internazionale" },
  { value: <span className="font-serif text-3xl sm:text-4xl text-[var(--ink)] leading-tight">Ferrari · TIM · FiberCop</span>, caption: "Esperienze executive" },
  { value: <span className="font-serif text-3xl sm:text-4xl text-[var(--ink)] leading-tight">Executive MBA · LUISS</span>, caption: "Formazione executive · Board Advisor" },
  { value: <span className="font-serif text-3xl sm:text-4xl text-[var(--ink)] leading-tight">AI · Risk · Digital · Board</span>, caption: "Principali aree di specializzazione" },
];

export const ExecutiveProfile = () => (
  <section id="executive-profile" data-testid="executive-profile-section" className="py-24 sm:py-32 border-b border-[var(--line)]">
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <Reveal className="overline mb-6">Executive Profile</Reveal>
      <h2 className="font-serif text-3xl sm:text-4xl leading-tight text-[var(--ink)] max-w-3xl mb-16">
        <RevealLine>Un percorso internazionale</RevealLine>
        <RevealLine delay={0.08} className="italic text-[var(--petrol)]">al servizio dei board.</RevealLine>
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-12 lg:gap-y-0">
        {BLOCKS.map((b, i) => (
          <Reveal key={i} delay={i * 0.12}
            className={`px-0 lg:px-10 ${i > 0 ? "lg:border-l lg:border-[var(--line)]" : "lg:pl-0"}`}>
            <div className="min-h-[4.5rem] flex items-start">{b.value}</div>
            <div className="overline !text-[var(--anthracite)] mt-5 leading-relaxed">{b.caption}</div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
